import React, { Component } from 'react';
import './App.css';
import LoginScreen from './LoginScreen';
import HomeScreen from './HomeScreen';
import { Route, Switch } from 'react-router-dom';
import { MuiThemeProvider } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { ConnectedRouter } from 'connected-react-router';
import { history } from '../app-store';
import locationHelperBuilder from 'redux-auth-wrapper/history4/locationHelper';
import { connectedRouterRedirect } from 'redux-auth-wrapper/history4/redirect';
import SignUpScreen from './SignUpScreen';
import UpdateRequestPortal from './UpdateRequestPortal';
import { StripeProvider } from 'react-stripe-elements';
import { dockPadTheme } from './dockPadStyle';
import { MuiPickersUtilsProvider } from 'material-ui-pickers';
import MomentUtils from '@date-io/moment';
import bugsnagClient from '../utils/BugSnagClient';
import { JoinLinkPortal } from './JoinLinkPortal'
import { DownloadPortal } from './DownloadPortal';

const LoadingScreen = () => (
  <div
    style={{
      width: '100%',
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex'
    }}
  >
    <CircularProgress />
  </div>
);

const locationHelper = locationHelperBuilder({});

export const UserIsAuthenticated = connectedRouterRedirect({
  wrapperDisplayName: 'UserIsAuthenticated',
  AuthenticatingComponent: LoadingScreen,
  allowRedirectBack: true,
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || '/login',
  authenticatingSelector: ({ firebase: { auth, profile, isInitializing } }) =>
    !auth.isLoaded || isInitializing === true,
  authenticatedSelector: ({ firebase: { auth } }) =>
    auth.isLoaded && !auth.isEmpty,
  redirectAction: newLoc => dispatch => {
    history.replace(newLoc); // or routerActions.replace
    dispatch({ type: 'UNAUTHED_REDIRECT' });
  }
});

export const UserIsNotAuthenticated = connectedRouterRedirect({
  wrapperDisplayName: 'UserIsNotAuthenticated',
  AuthenticatingComponent: LoadingScreen,
  allowRedirectBack: false,
  redirectPath: (state, ownProps) =>
    locationHelper.getRedirectQueryParam(ownProps) || '/',
  authenticatingSelector: ({ firebase: { auth, isInitializing } }) =>
    !auth.isLoaded || isInitializing === true,
  authenticatedSelector: ({ firebase: { auth } }) =>
    auth.isLoaded && auth.isEmpty,
  redirectAction: newLoc => dispatch => {
    history.replace(newLoc); // or routerActions.replace
    dispatch({ type: 'UNAUTHED_REDIRECT' });
  }
});

// wrap your entire app tree in the ErrorBoundary provided
const ErrorBoundary = bugsnagClient.getPlugin('react');

class App extends Component {
  render() {
    return (
      <ErrorBoundary>
        <MuiThemeProvider theme={dockPadTheme}>
          <ConnectedRouter history={history}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <StripeProvider apiKey="pk_test_849dqCkrj1cxOls33fDgmKZ0">
                <Switch>
                  <Route
                    path="/updateRequest/:id/portal"
                    component={UpdateRequestPortal}
                  />
                  <Route
                    path="/join"
                    component={JoinLinkPortal}
                  />
                  <Route
                    path="/download"
                    component={DownloadPortal}
                  />

                  <Route
                    path="/login"
                    component={UserIsNotAuthenticated(LoginScreen)}
                  />
                  <Route
                    path="/signup"
                    component={UserIsNotAuthenticated(SignUpScreen)}
                  />
                  <Route path="/" component={UserIsAuthenticated(HomeScreen)} />
                </Switch>
              </StripeProvider>
            </MuiPickersUtilsProvider>
          </ConnectedRouter>
        </MuiThemeProvider>
      </ErrorBoundary>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/containers/App.tsx